export default class AccountsReceivableParams {
    constructor(
      public prefix: string,
      public type: string,
      public nature: string,
      public carrier: string,
      public defaultFeePercentage: number,
    ) {}

    static make(data: any): AccountsReceivableParams {
        return new AccountsReceivableParams(
            data.prefix,
            data.type,
            data.nature,
            data.carrier,
            data.default_fee_percentage,
        );
    }
}
